// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TVQUC","logoWrapper":"styles_logoWrapper__k3u1j","text":"styles_text__BHUHV"};